import { AnalysisEntry, ExtendedAttributeCode } from 'pages/trading/model';
import { BandChartConfig } from 'components/chart/data/BandChartConfig';
import { transparentUpperAndLowerGradientCreator } from 'components/chart/renderer/GradientCreator';
import { Measure } from 'services/model/model.service';
import { useIntl } from 'react-intl';
import { Chart } from 'components/chart/Chart';
import { BandChartRenderer } from 'components/chart/renderer/BandChartRenderer';
import { useTranslatedAttribute } from 'pages/trading/queryHooks';

export interface AnalysisEntryBandChartProps {
  measure: Measure;
  selectedEntry: AnalysisEntry;
  height?: string;
  testId?: string;
}

export function AnalysisEntryBandChart({
  measure,
  selectedEntry,
  height = '300px',
  testId = undefined,
}: AnalysisEntryBandChartProps) {
  const intl = useIntl();

  const { data: translatesdAttributeName } = useTranslatedAttribute(
    selectedEntry.code as ExtendedAttributeCode,
    selectedEntry.attributeValue
  );

  const chartConfig = BandChartConfig.forMeasure(
    measure,
    { ...selectedEntry, attributeValue: translatesdAttributeName ?? '' },
    transparentUpperAndLowerGradientCreator('#e2e2e2'),
    intl
  );

  return (
    <div data-testid={testId}>
      <Chart className="mt-3" height={height} renderer={new BandChartRenderer(chartConfig)} />
    </div>
  );
}
